module.exports = __webpack_public_path__ + "static/img/cont3001.6bd5d08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3001.jpg
// module id = dvgB
// module chunks = 0